import { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { CHUNK_LOAD_RELOAD_SESSION_KEY, isChunkLoadFailure } from '@/lib/chunk-load-errors';

/**
 * Affiché par React Router quand une route lève une erreur (ex. échec d’import dynamique non géré).
 * Pour les chunks obsolètes après déploiement : rechargement automatique une fois.
 */
export function RootRouteErrorFallback() {
  const err = useRouteError();

  useEffect(() => {
    if (!isChunkLoadFailure(err) || typeof window === 'undefined') return;
    if (window.sessionStorage.getItem(CHUNK_LOAD_RELOAD_SESSION_KEY) === '1') return;
    window.sessionStorage.setItem(CHUNK_LOAD_RELOAD_SESSION_KEY, '1');
    window.location.reload();
  }, [err]);

  if (isChunkLoadFailure(err)) {
    return (
      <div
        className="flex min-h-[50vh] flex-col items-center justify-center gap-3 px-4"
        role="status"
        aria-live="polite"
      >
        <Loader2 className="h-10 w-10 animate-spin text-[color:var(--inst-player-primary,#0C1C38)]" aria-hidden />
        <p className="text-center text-sm text-slate-600 dark:text-slate-400">
          Mise à jour de l’application en cours…
        </p>
      </div>
    );
  }

  const message =
    err instanceof Error ? err.message : typeof err === 'string' ? err : 'Une erreur est survenue.';

  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 px-4 text-center">
      <p className="text-sm font-medium text-slate-800 dark:text-slate-200">{message}</p>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="rounded-lg bg-[color:var(--inst-player-primary,#0C1C38)] px-4 py-2 text-sm font-medium text-white hover:opacity-90"
      >
        Rafraîchir la page
      </button>
    </div>
  );
}
